import React from "react"
import {Link} from "react-router-dom"
import {Page} from "../../components-shared/page/page"

export const ConfirmPage: React.FC = () => {
  return <Page title="Emailadres bevestigd">
    Je emailadres is succesvol bevestigd. <Link to="/login">Inloggen</Link>
  </Page>
}